module.exports = __webpack_public_path__ + "img/home-07-cosmopolitan-sample-04-street-01.9da1a18e.jpg";